import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const Invoicing = {
  InvoicingList: lazyNamed(() => import('./containers/InvoicingList/index.tsx'), 'InvoicingList'),
};
